import React from "react";
import { Link, NavLink } from "react-router-dom";
import "./Footer.css";

// Import Font Awesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import {
  faMapMarkerAlt,
  faPhoneAlt,
  faEnvelope,
  faClock,
} from "@fortawesome/free-solid-svg-icons";

export const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-col footer-about">
            <NavLink to="/" className="footer-brand">
              <img
                src="/img/icon.png"
                alt="Technosun Enterprises Logo"
                className="footer-logo"
              />
              TECHNOSUN ENTERPRISES
            </NavLink>
            <p className="footer-about-text">
              As the leading solar energy solutions provider in Delhi NCR, we
              specialize in helping homes and businesses transition to clean,
              renewable energy since 2024. Our expert team delivers customized
              solar solutions with premium components, government subsidy
              assistance, and comprehensive after-sales support.
            </p>
            <div className="footer-social">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <FontAwesomeIcon icon={faYoutube} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-col footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/services">Our Services</Link>
              </li>
              <li>
                <Link to="/portfolio">Projects</Link>
              </li>
              <li>
                <Link to="/blog">Blog</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              <li>
                <Link to="/careers">Careers</Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-col footer-services">
            <h4>Our Services</h4>
            <ul>
              <li>
                <Link to="#">Residential Solar Systems</Link>
              </li>
              <li>
                <Link to="#">Commercial Solar Solutions</Link>
              </li>
              <li>
                <Link to="#">Industrial Solar Plants</Link>
              </li>
              <li>
                <Link to="#">Solar Water Heaters</Link>
              </li>
              <li>
                <Link to="#">Annual Maintenance Contracts</Link>
              </li>
              <li>
                <Link to="#">Subsidy Consultation</Link>
              </li>
              <li>
                <Link to="#">Solar EV Charging Stations</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-col footer-contact">
            <h4>Contact Us</h4>
            <ul className="contact-info">
              <li>
                <FontAwesomeIcon
                  icon={faMapMarkerAlt}
                  className="contact-icon"
                />
                <div className="contact-text">
                  <strong>Head Office:</strong>
                  <br />
                  5A-31, Cloud-9, Sector-1, Vaishali,
                  <br />
                  Ghaziabad, 201010 U.P.
                </div>
              </li>
              <li>
                <FontAwesomeIcon icon={faPhoneAlt} className="contact-icon" />
                <div className="contact-text">
                  <span>+91 9211247248</span>
                  <br />
                  {/* <span>+91 11 2345 6789</span> */}
                </div>
              </li>
              <li>
                <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                <div className="contact-text">
                  <span>sales@technosunenterprises.com</span>
                  <br />
                  <span>info@technosunenterprises.com</span>
                </div>
              </li>
              <li>
                <FontAwesomeIcon icon={faClock} className="contact-icon" />
                <div className="contact-text">
                  <span>Monday-Saturday: 9:00 AM - 6:00 PM</span>
                  <br />
                  <span>Emergency Support: 24/7</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
           <div className="copyright">
            &copy; {new Date().getFullYear()} TechnoSun Enterprises. All Rights Reserved.
          </div> 
          {/* <div className="copyright">
            &copy; {new Date().getFullYear()} TechnoSun Enterprises. All Rights Reserved. | 
            GSTIN: 09ABCDE1234F1Z5 | CIN: U74999DL2015PTC123456
          </div> */}
          <div className="footer-legal">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <a href="/sitemap.xml">Sitemap</a>
            <Link to="/disclaimer">Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
